<template>
  <div class="participant entrant">
    <div class="form-group col-12">
      <div class="form-row">
        <div class="col-md-6 col-sm-12">
          <h4><span class="entrantTitle">受講者{{index + 1}}</span> <span v-if="index==0" class="badge badge-danger">必須</span></h4>
        </div>
        <div class="col-md-6 col-sm-12">
          <button type="button" class="btn btnRemoveEntrant" style="margin-bottom:10px" v-show="index > 0" :data-key="item.key" @click="onRemoveEntrant">
            <i class="fas fa-minus"></i>　この受講者を削除する
          </button>
        </div>
      </div>
    </div>
    <div class="form-group col-12">
      <label class="h5" for="">受講者氏名</label> <span class="badge badge-danger">必須</span>
      <div class="form-row">
        <div class="col-6">
          <validation-provider rules="valid-name" v-slot="{ errors }">
            <label :for="'txtEntNameFamily'+item.key">姓</label>
            <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" :id="'txtEntNameFamily'+item.key" placeholder="" v-model="item.nameFamily">
            <div class="text-danger">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-6">
          <validation-provider rules="valid-name" v-slot="{ errors }">
            <label :for="'txtEntNameFirst'+item.key">名</label>
            <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" :id="'txtEntNameFirst'+item.key" placeholder="" v-model="item.nameFirst">
            <div class="text-danger">{{ errors[0] }}</div>
          </validation-provider>
        </div>
      </div>
      <div class="form-row">
        <div class="col-6">
          <validation-provider rules="kana-only" v-slot="{ errors }">
            <label :for="'txtEntKanaFamily'+item.key">姓＜全角カナ＞</label>
            <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" :id="'txtEntKanaFamily'+item.key" placeholder="" v-model="item.kanaFamily">
            <div class="text-danger">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-6">
          <validation-provider rules="kana-only" v-slot="{ errors }">
            <label :for="'txtEntKanaFirst'+item.key">名＜全角カナ＞</label>
            <input type="text" class="form-control" :class="{ 'is-invalid': errors[0] }" :id="'txtEntKanaFirst'+item.key" placeholder="" v-model="item.kanaFirst">
            <div class="text-danger">{{ errors[0] }}</div>
          </validation-provider>
        </div>
      </div>
    </div>
    <div class="form-group col-12 mt-4">
      <label class="h5" for="">ご担当教科等</label>
      <div class="form-row">
        <div class="col-md-3 col-6">
          <validation-provider rules="required" v-slot="{ errors }">
            <label :for="'selEntSubject'+item.key">ご担当教科</label> <span class="badge badge-danger">必須</span>
            <select class="custom-select d-block" :class="{ 'is-invalid': errors[0] }" :id="'selEntSubject'+item.key" v-model="item.subject">
              <option v-for="i in $store.getters.subjectList" :key="i.code" :value="i.code">{{i.name}}</option>
            </select>
          </validation-provider>
        </div>
        <div class="col-md-3 col-6">
          <validation-provider rules="required" v-slot="{ errors }">
            <label :for="'selEntGrade'+item.key">学年</label> <span class="badge badge-danger">必須</span>
            <select class="custom-select d-block" :class="{ 'is-invalid': errors[0] }" :id="'selEntGrade'+item.key" v-model="item.grade">
              <option v-for="i in $store.getters.gradeList" :key="i.code" :value="i.code">{{i.name}}</option>
            </select>
          </validation-provider>
        </div>
        <div class="col-md-6 col-12">
          <label :for="'txtEntDivision'+item.key">校務分掌</label>
          <input type="text" class="form-control" :id="'txtEntDivision'+item.key" placeholder="" v-model="item.division">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'EntryEntrant',
  props: {
    index: Number,
    item: Object
  },
  components: {
    ValidationProvider
  },
  methods: {
    onRemoveEntrant: function(e) {
      var key = e.currentTarget.dataset.key
      this.$store.dispatch('entry/removeEntrant', { key })
    }
  }
}
</script>
